uniform vec3 uSpotLightPosition;
uniform vec3 uSpotLightTarget;
uniform vec3 uSpotLightColor;
uniform float uSpotLightIntensity;
uniform float uSpotLightAngle;
uniform float uSpotLightPenumbra;
uniform float uSpotLightRange;
uniform float uAmbient;

varying vec3 vColor;
varying vec3 vWorldPosition;

void main()
{
    float distanceToCenter = length(gl_PointCoord - 0.5);
    if(distanceToCenter > 0.5)
        discard;
    
    vec3 lightDirection = normalize(uSpotLightTarget - uSpotLightPosition);
    vec3 toFragment = vWorldPosition - uSpotLightPosition;
    float distanceToLight = length(toFragment);
    vec3 toFragmentDirection = normalize(toFragment);

    float angleCos = dot(toFragmentDirection, lightDirection);
    float inner = cos(uSpotLightAngle * 0.5);
    float outer = cos(uSpotLightAngle * 0.5 * (1.0 + uSpotLightPenumbra));
    float spot = smoothstep(outer, inner, angleCos);

    float rangeAttenuation = 1.0 - smoothstep(uSpotLightRange * 0.7, uSpotLightRange, distanceToLight);
    float lightStrength = spot * rangeAttenuation * uSpotLightIntensity;

    vec3 litColor = vColor * (uAmbient + lightStrength * uSpotLightColor);
    gl_FragColor = vec4(litColor, 1.0);

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}
